export default __webpack_public_path__ + "static/product10-e6b4345f8f39314f14d2fa1d99b2182c.png";